import { render, staticRenderFns } from "./OrderSubmit.vue?vue&type=template&id=9c9ab1f6&scoped=true&"
import script from "./OrderSubmit.vue?vue&type=script&lang=js&"
export * from "./OrderSubmit.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubmit.vue?vue&type=style&index=0&id=9c9ab1f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9ab1f6",
  null
  
)

export default component.exports